
export default (paragraph = `# Welcome to Your New Email Template!

Ready to connect with your customers? If you haven't already added your company logo in the account settings, go ahead and do it to make every email look like it comes straight from you. This template can be used for any task—whether it's a one-off send or part of a campaign.

You can also change up the logo and the button below to match your brand colors. Don't forget to add. It’s super easy to update these in your account preferences whenever you need to.
`) => {
function alignParagraphsLeft(htmlString, color = "#000000") {
  // Create a temporary DOM element to hold the HTML in memory
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  // Find all <p> elements and add the 'text-align: left' style
  const paragraphs = tempDiv.querySelectorAll('p');
  paragraphs.forEach(el => {
    el.style.textAlign = 'left'
    el.style.color = '#123456'
  })
  const h1s = tempDiv.querySelectorAll('h1');
  h1s.forEach(el => {
    el.style.textAlign = 'left' 
    el.style.color = '#123456'   
  });

  const h2s = tempDiv.querySelectorAll('h2');
  h2s.forEach(el => {
    el.style.textAlign = 'left'
    el.style.color = '#123456'
  })

  const h3s = tempDiv.querySelectorAll('h3');
  h3s.forEach(el => {
    el.style.textAlign = 'left'
    el.style.color = '#123456'
  })

  const h4s = tempDiv.querySelectorAll('h4');
  h4s.forEach(el => {
    el.style.textAlign = 'left'
    el.style.color = '#123456'
  })
  // Return the modified HTML string
  console.log(tempDiv.innerHTML)

  //this replaces the hardcoded generated string with the color, this is a hack to get around this for now.   
  return tempDiv.innerHTML.replace(/color: rgb\(18, 52, 86\)/g, color)
}
  return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html
  xmlns="http://www.w3.org/1999/xhtml"
  style="
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    line-height: 1.65;
    font-size: 100%;
    font-family: 'Avenir Next', 'Helvetica Neue', 'Helvetica', Helvetica, Arial,
      sans-serif;
  "
>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width" />
  </head>

  <body align="center" style="margin: 0; padding: 0; background: {{ AccountPreference.email_color_body_background }}">
    <div class="background" style="background: {{ AccountPreference.email_color_background }}">
      <div class="foreground" style="max-width: 600px; background: {{ AccountPreference.email_color_foreground }}">
        <table
          style="
            max-width: 600px;
            margin: 0 auto 0;
            padding: 0 0 40px 0;
            text-align: center;
            background: transparent;
            border-radius: 0.35rem;
            border-spacing: 0;
          "
        >
          <tr>
            <td
              class="vastreach-sections"
              data-vast-editor="img-picker"
              style="padding: 0"
            >
              <!-- Dynamic WYSIWYG Content -->
              <table
                style="
                  width: 100%;
                  max-width: 600px;
                  margin: 0 auto 0;
                  padding: 0;
                  text-align: center;
                  background: {{ AccountPreference.company_logo_bgcolor_color }};
                "
              >
                <tbody>
                  <tr>
                    <td>
                      <img
                        src="{{ AccountPreference.company_logo_url_color }}"
                        alt="logo"
                        style="max-width: 100%; margin: 0 auto; display: block"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- End of Dynamic WYSIWYG Content -->
            </td>
          </tr>
					<tr>
						<td
							class="vastreach-sections"
							data-vast-editor="paragraph"							
              style="padding: 8px"
						>
						
								${alignParagraphsLeft(
                  window?.marked?.parse(paragraph) || paragraph,
                  '{{ AccountPreference.email_color_text_paragraph }}',
                )}
						
						</td>
					</tr>
          <tr>
            <td
              class="vastreach-sections"
              data-vast-editor="button"
              style="padding: 0"
            >
              <!-- Dynamic WYSIWYG Content -->
              <div
                style="
                  max-width: 600px;
                  margin: 0 auto 0;
                  padding: 10px 0;
                  text-align: center;
                  background: transparent;
                  line-height: 1.65;
                  font-size: 100%;
                  font-family: Arial, Helvetica, sans-serif;
                "
              >
                <p style="text-align: center; margin: 0">
                  <a
                    data-button-text="Start now"
                    data-button-url="{{ AccountPreference.company_website }}"
                    data-button-color="{{ AccountPreference.email_color_button_text }}"
                    data-button-background-color="{{ AccountPreference.email_color_button_background }}"
                    href="{{ AccountPreference.company_website }}"
                    target="_blank"
                    ><button
                      style="
                        color: {{ AccountPreference.email_color_button_text }};
                        background-color: {{ AccountPreference.email_color_button_background }};
                        border: 0;
                        padding: 15px 25px;
                        margin: 0;
                        border-radius: 0.35rem;
                        cursor: pointer;
                      "
                    >
                      <strong>Start Now</strong>
                    </button></a
                  >
                </p>
              </div>
              <!-- End of Dynamic WYSIWYG Content -->
            </td>
          </tr>
        </table>
      </div>
    </div>
  </body>
</html>`
}
